/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_ConstructionEmail,
  ListCommandResult_ConstructionEmail
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TConstructionType,
  TConstructionEmailType,
  TJoin,
  TNonEmptyArray,
  TContractType,
  TClientType
} from "@graphql/helpers/utils.graphql";

type TConstructionEmailByIdFunctions = {
  getByID: CommandResult_ConstructionEmail;
};
export type TConstructionEmailByIdQueries = {
  constructionEmail: TConstructionEmailByIdFunctions;
};

type TGlobal =
  | TConstructionEmailType
  | TJoin<"construction", TConstructionType>
  | TJoin<"construction.client", TClientType>
  | TJoin<"construction.contracts", TContractType>;

export const constructionEmailById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query constructionEmailById($id: Guid!) {
    constructionEmail {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConstructionEmail")}
`;

type TConstructionEmailAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ConstructionEmail;
};
export type TConstructionEmailAllWithPaginationQueries = {
  constructionEmail: TConstructionEmailAllWithPaginationFunctions;
};
export const constructionEmailAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query constructionEmailAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    constructionEmail {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ConstructionEmail")}
`;
